import * as Sentry from '@sentry/gatsby'
import type {
  ReleaseMenuCardData,
  UseReleaseMenuCardQuery,
} from 'component-library'
import { gql, GraphQLClient } from 'graphql-request'
import { useEffect, useState } from 'react'
import { mapLatestReleaseBlogPostToNavbarCard } from 'shared-utilities'
import { getCurrentEnvConfig } from '../../config'

const graphQLClient = new GraphQLClient(getCurrentEnvConfig().graphql)

const LATEST_RELEASE_BLOG_QUERY = gql`
  query LatestReleaseBlogPost {
    blogPostForLatestRelease {
      title
      slug
      features {
        thumbnail
      }
    }
  }
`

interface LatestReleaseBlogQueryResponse {
  blogPostForLatestRelease: {
    title: string
    slug: string
    features: Array<{ thumbnail: string }>
  } | null
}

export const useReleaseMenuCardQuery: UseReleaseMenuCardQuery = ({ limit }) => {
  const [items, setItems] = useState<ReleaseMenuCardData[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    let cancelled = false

    const fetchReleaseCard = async () => {
      setIsLoading(true)
      setIsError(false)

      try {
        const data =
          await graphQLClient.request<LatestReleaseBlogQueryResponse>(
            LATEST_RELEASE_BLOG_QUERY
          )

        if (cancelled) {
          return
        }

        const card = mapLatestReleaseBlogPostToNavbarCard(
          data.blogPostForLatestRelease
        )

        setItems(card ? [card].slice(0, limit) : [])
      } catch (error) {
        console.error(error)
        Sentry.captureException(error)

        if (!cancelled) {
          setIsError(true)
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false)
        }
      }
    }

    fetchReleaseCard()

    return () => {
      cancelled = true
    }
  }, [limit])

  return { items, isLoading, isError }
}
